import { useEffect } from 'react';
import { useProductionQueues } from '../../../../queryHooks/useProductionsQueues';
import { useGroupedQueuesStore } from '../store';
import { useCustomTranslation } from '../../../../hooks';
import { useCustomToast } from '@nexelem/snackbar';

export const useLoadQueues = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const displayToast = useCustomToast();
  const setGroupedQueues = useGroupedQueuesStore((state) => state.setQueues);

  const { data: queues, isFetching, isError } = useProductionQueues();

  useEffect(() => {
    if (queues) {
      setGroupedQueues(queues);
    }
  }, [setGroupedQueues, queues]);

  useEffect(() => {
    if (isError) {
      displayToast({
        toastType: 'error',
        message: tWrapper('errorMessage'),
      });
    }
  }, [tWrapper, displayToast, isError]);

  return { isError, isFetching };
};
